import type { ApiRequester } from "@/shared/api"

export class LogsApi {
  constructor(private readonly api: ApiRequester) {}

  list(payload: iSharedLogs.LogsListPayloadDto = {}): Promise<iSharedLogs.LogsListResponseDto> {
    return this.api.get<iSharedLogs.LogsListResponseDto>({
      path: this.getListPath(payload),
      commit: "logs/setLogs"
    })
  }

  markRead(logUid: string): Promise<iSharedLogs.LogsMutationResponseDto> {
    return this.api.post({ path: "/logs/read", payload: { logUid } })
  }

  markAllRead(packageUid: string): Promise<iSharedLogs.LogsMutationResponseDto> {
    return this.api.post({ path: "/logs/read-all", payload: { packageUid } })
  }

  private getListPath(payload: iSharedLogs.LogsListPayloadDto): "/logs" | `/logs?${string}` {
    const params = new URLSearchParams()

    if (payload.limit !== undefined) params.set("limit", String(payload.limit))
    if (payload.offset !== undefined) params.set("offset", String(payload.offset))
    if (payload.level) params.set("level", payload.level)
    if (payload.kind) params.set("kind", payload.kind)
    if (payload.packageUid) params.set("packageUid", payload.packageUid)

    const query = params.toString()
    return query ? `/logs?${query}` : "/logs"
  }
}
